import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSecure = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#A)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M8.211.034l4.177 1.393a3.33 3.33 0 0 1 2.279 3.162V8c0 5.042-6.133 7.827-6.396 7.943C8.186 15.98 8.093 16 8 16s-.185-.02-.271-.058C7.467 15.826 1.334 13.042 1.334 8V4.588a3.33 3.33 0 0 1 2.279-3.162L7.79.034c.137-.046.285-.046.421 0zM8 14.592c1.121-.571 5.333-2.956 5.333-6.593V4.588a2 2 0 0 0-1.368-1.897L8 1.369 4.035 2.691a2 2 0 0 0-1.368 1.897V8c0 3.646 4.211 6.024 5.333 6.593zm-.592-6.259l2.792-2.8a.67.67 0 0 1 .473-.195.67.67 0 0 1 .473.196.67.67 0 0 1 .196.473.67.67 0 0 1-.197.473L8.297 9.328a1.25 1.25 0 0 1-.89.369h-.022a1.25 1.25 0 0 1-.897-.4l-1.537-1.6c-.063-.063-.113-.137-.147-.219s-.051-.17-.051-.259.019-.177.054-.259.086-.156.15-.217.14-.11.223-.142.172-.047.261-.044.176.023.257.061.153.09.213.156l1.496 1.56z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "A",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgSecure;
